const T = "input-field";
export {
  T as INPUT_FIELD_DEFAULT_TESTID
};
//# sourceMappingURL=index.es835.js.map
